module.exports = __webpack_public_path__ + "img/despesas.37e5331d.svg";